<template>
  <v-container class="mt-4">
    <div class="d-flex align-center justify-center">
      <v-overlay scrollable v-model="showEmployOverlay">
        <EmployListPopup :EmployList="employToSend"/>
      </v-overlay>
    </div>
    <v-autocomplete v-if="!selectedVacationishperiod"
      label="Wunschperiode Suche"
      :items="wishperiodsData"
      item-title="title"
      item-value="title"
      clearable
      v-model="selectedWishperiod"
      no-data-text="Keine wunschperiode gefunden"
      return-object
    ></v-autocomplete>
    <v-autocomplete v-if="!selectedWishperiod"
      label="Urlaubswunschperiode Suche"
      :items="vacationperiodsData"
      item-title="year"
      item-value="year"
      clearable
      v-model="selectedVacationishperiod"
      no-data-text="Keine wunschperiode gefunden"
      return-object
    ></v-autocomplete>
    <div v-if="selectedWishperiod">
      <p class="mb-2"><b>Wunschperiode: {{selectedWishperiod.title}}</b></p>
      <v-autocomplete
          v-model="selectedEmployCycles"
          :items="employCycles"
          label="Schichten auswählen"
          multiple
          chips
          clearable
      />
      
      <v-row>
        <v-col cols="6">
          <VCheckbox class="mb-2 v-checkbox--default" label="Keinen WDP eingereicht" v-model="hasNotSubmittedFilter"></VCheckbox>
        </v-col>
        <v-col cols="6">
          <VCheckbox class="mb-2 v-checkbox--default" label="WDP noch nicht geöffnet" v-model="hasNotOpenedWdp"></VCheckbox>
        </v-col>
      </v-row>
<!--      <v-row>
        <v-col cols="6">
          <VCheckbox class="mb-2 v-checkbox--default" label="Keinen WDP erstellt" v-model="hasNoWdpFilter"></VCheckbox>
        </v-col>
      </v-row>-->
      
      <v-textarea class="mt-4" rows="1" clearable v-model="manuelEmail" label="Manuelle Email" variant="solo-filled"/>
      <v-textarea class="mt-4" rows="1" clearable v-model="notificationSubject" label="Betreff" variant="solo-filled"/>
      <v-textarea class="mt-4" rows="8" clearable v-model="notificationText" label="Nachricht einfügen" variant="solo-filled"/>
    </div> 
    <div v-if="selectedVacationishperiod">
      <p class="mb-2"><b>Urlaubswunschperiode: {{selectedVacationishperiod.year}}</b></p>
      <v-autocomplete
          v-model="selectedEmployCycles"
          :items="employCycles"
          label="Schichten auswählen"
          multiple
          chips
          clearable
      />
      
      <v-row>
        <v-col cols="6">
          <VCheckbox class="mb-2 v-checkbox--default" label="Keinen UP eingereicht" v-model="hasNotSubmittedUpFilter"></VCheckbox>
        </v-col>
        <v-col cols="6">
          <VCheckbox class="mb-2 v-checkbox--default" label="UP noch nicht geöffnet" v-model="hasNotOpenedUp"></VCheckbox>
        </v-col>
      </v-row>

      <v-textarea class="mt-4" rows="1" clearable v-model="manuelEmail" label="Manuelle Email" variant="solo-filled"/>
      <v-textarea class="mt-4" rows="1" clearable v-model="notificationSubject" label="Betreff" variant="solo-filled"/>
      <v-textarea class="mt-4" rows="8" clearable v-model="notificationText" label="Nachricht einfügen" variant="solo-filled"/>
    </div>
    <div class="d-flex align-center w-100 justify-center flex-column">
      <v-btn @click="() => {showEmployOverlay = true}" class="mt-4 w-100" color="secondary">{{"Mitarbeiter ansehen (" + employCount + ")"}}</v-btn>
      <v-btn  v-if="selectedWishperiod" @click="sendBenachrichtigungWDP" class="ma-4 w-100" color="primary">Benachrichtigung senden</v-btn>
      <v-btn  v-if="selectedVacationishperiod" @click="sendBenachrichtigungUP" class="ma-4 w-100" color="primary">Benachrichtigung senden</v-btn>
      <v-progress-linear
          v-if="isSending"
          height="12"
          :max="maxToSend"
          min="0"
          :model-value="alreadySend"
          rounded
      ></v-progress-linear>
    </div>
  </v-container>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue';
import {collection, addDoc, query, where} from "firebase/firestore";
import {useCollection, useFirestore} from "vuefire";
import {notifyInfo, notifySuccess, notifyWarning} from "vuetify3-dialog";
import EmployListPopup from "@/components/EmployListPopup.vue";
const db = useFirestore();
const employ = useCollection(collection(db, 'employ'));

const wishData = useCollection(collection(db, 'wishData'));
const wishperiodsData = useCollection(query(collection(db, 'wishPeriods'), where('hidden', '==', false)));
const vacationData = useCollection(collection(db, 'vacationData'));
const vacationperiodsData = useCollection(query(collection(db, 'vacationPeriods'), where('hidden', '==', false)));
const userData = useCollection(collection(db, 'userData'));


const selectedEmployCycles = ref([]);
const selectedWishperiod = ref(null);
const selectedVacationishperiod = ref(null);
const manuelEmail = ref('');
const notificationText = ref('');
const notificationSubject = ref('');
const showEmployOverlay = ref(false);
const maxToSend = ref(0);
const alreadySend = ref(0);
const isSending = ref(false);

const hasNoWdpFilter = ref(false);
const hasNotSubmittedFilter = ref(false);
const hasNotOpenedWdp = ref(false);
const hasNotSubmittedUpFilter = ref(false);
const hasNotOpenedUp = ref(false);

const employCycles = computed(() => {
  return new Set(employ.value.map(element => element.cycleid));
});

const employToSend = computed(() => {
  var returnEmploys = [];
  
  returnEmploys = employ.value.filter(element => selectedEmployCycles.value.includes(element.cycleid));
  
  if(hasNoWdpFilter.value){
    const filteredEmployees = returnEmploys.filter(employee =>
        !userData.value.some(entry => entry.email === employee.adacount)
    );

    returnEmploys = filteredEmployees;
  }
  
  if(hasNotSubmittedFilter.value){
    const filteredEmployees = returnEmploys.filter(employee => {
      const user = userData.value.find(user => user.email === employee.adacount);
      if (!user) return false; // No corresponding user found
      console.log("Wunschperiode", selectedWishperiod.value)
      if (!selectedWishperiod) return false; // No wishperiod selected
      const wish = wishData.value.find(wish => wish.employNr === user.emplno && wish.wishPeriodId === selectedWishperiod.value.id);
      //return wish ? !wish.finished : false; // Only include if isActive is true
      return !wish || !wish.finished;
    });
    
    returnEmploys = filteredEmployees;
  }
  
  if(hasNotOpenedWdp.value || hasNotOpenedUp.value){
    const filteredEmployees = returnEmploys.filter(employee =>
        !userData.value.some(user => user.email === employee.adacount)
    );
    
    returnEmploys = filteredEmployees;
  }
  
  if (hasNotSubmittedUpFilter.value){
    const filteredEmployees = returnEmploys.filter(employee => {
      const user = userData.value.find(user => user.email === employee.adacount);
      if (!user) return false; // No corresponding user found
      console.log("Urlaubswunschperiode", selectedVacationishperiod.value)
      if (!selectedVacationishperiod) return false; // No wishperiod selected
      const vacation = vacationData.value.find(wish => wish.employNr === user.emplno && wish.year === String(selectedVacationishperiod.value.year));
      return !vacation;
    });
    console.log("Filtered Employees for UP:", filteredEmployees);
    returnEmploys = filteredEmployees;
  }

  return returnEmploys;
});

const employCount = computed(() => {
  return employToSend.value.length;
});

const sendBenachrichtigungWDP = async () => {
  if (employToSend.value.length > 0) {

    maxToSend.value = employToSend.value.length;
    isSending.value = true;
    alreadySend.value = 0;

    await Promise.all(employToSend.value.map(async (employ) => {
      await addDoc(collection(db, "mail"), {
        to: employ.email,
        message: {
          subject: notificationSubject.value,
          text: notificationText.value,
        },
      });
      alreadySend.value++;
    }));
  }
  
  if(manuelEmail.value){
    await addDoc(collection(db, "mail"), {
      to: manuelEmail.value,
      message: {
        subject: notificationSubject.value,
        text: notificationText.value,
      },
    });
  }

  setTimeout(async () => {
    isSending.value = false;
    alreadySend.value = 0;
    maxToSend.value = 0;
    manuelEmail.value = '';
    notificationText.value = '';
    notificationSubject.value = '';
    selectedEmployCycles.value = [];
    showEmployOverlay.value = false;
    await notifyInfo('Emails wurden versendet');
  }, 1000)
}

const sendBenachrichtigungUP = async () => {
  if (employToSend.value.length > 0) {

    maxToSend.value = employToSend.value.length;
    isSending.value = true;
    alreadySend.value = 0;

    await Promise.all(employToSend.value.map(async (employ) => {
      await addDoc(collection(db, "mail"), {
        to: employ.email,
        message: {
          subject: notificationSubject.value,
          text: notificationText.value,
        },
      });
      alreadySend.value++;
    }));
  }
  
  if(manuelEmail.value){
    await addDoc(collection(db, "mail"), {
      to: manuelEmail.value,
      message: {
        subject: notificationSubject.value,
        text: notificationText.value,
      },
    });
  }

  setTimeout(async () => {
    isSending.value = false;
    alreadySend.value = 0;
    maxToSend.value = 0;
    manuelEmail.value = '';
    notificationText.value = '';
    notificationSubject.value = '';
    selectedEmployCycles.value = [];
    showEmployOverlay.value = false;
    await notifySuccess('Emails wurden versendet');
  }, 1000)
}

</script>